import { getSiteBrand } from "@/lib/siteHosts";

export const SPEED_GAP_OUTCOME_BADGE = {
  metric: "+6 APPOINTMENTS / WEEK",
  context: "Live proof · partner deployment · not a projection",
};

export const SPEED_GAP_AGENCY_PAIN = {
  label: "THE AGENCY MIRROR",
  body: "You still report CPL and CTR in the client dashboard. The job was lost on their side. But you'll eat the churn, the blame, and the RFP from their competitor's agency.",
};

export const SPEED_GAP_THESIS = {
  headline: "Your ads convert. Your client's reply speed doesn't.",
  subline:
    "Emergency leads don't wait for Monday. If nobody answers in 60 seconds, the job goes to whoever does.",
};

export const SPEED_GAP_HUMAN_PATH = {
  label: "Your client's office hours",
  steps: [
    { time: "10:14 PM", text: "Lead arrives on WhatsApp" },
    { time: "...", text: "Voicemail / no answer" },
    { time: "Mon 9:00 AM", text: "Office opens. Too late." },
  ],
  result: "Job lost",
};

export const SPEED_GAP_AI_PATH = {
  get label() {
    return `${getSiteBrand().name} Digital Assistant`;
  },
  steps: [
    { time: "10:14:02", text: "Lead arrives · identity + address parsed" },
    { time: "10:14:04", text: "Scope vetted · qualifying questions sent" },
    { time: "10:14:35", text: "Damage photos captured · logged to job file" },
    { time: "10:14:55", text: "Policy passed · weather checked · CRM locked · inspection booked ✓" },
  ],
  result: "Full job file ready for estimator",
};

export const SPEED_GAP_SPEED_HERO = {
  value: "53 sec",
  contrastHeadline: "What your client's office does in 45 minutes:",
  pipeline: [
    "Qualify the lead",
    "Pull the address",
    "Request damage photos",
    "Check scope",
    "Validate weather",
    "Book the slot",
    "Write to CRM",
  ],
  caption: "Fully autonomous. No dispatcher. No Monday catch-up.",
};
